"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = exports.NavbarPages = void 0;
var React = __importStar(require("react"));
var Menu_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu"));
var config_1 = require("../../config");
var Mana_1 = require("../Mana/Mana");
var Blockie_1 = require("../Blockie/Blockie");
var Container_1 = require("../Container/Container");
var Header_1 = require("../Header/Header");
var Logo_1 = require("../Logo/Logo");
var Media_1 = require("../Media");
require("./Navbar.css");
var NavbarPages;
(function (NavbarPages) {
    NavbarPages["MARKETPLACE"] = "marketplace";
    NavbarPages["DOCS"] = "docs";
    NavbarPages["EVENTS"] = "events";
    NavbarPages["PLACES"] = "places";
    NavbarPages["AGORA"] = "agora";
    NavbarPages["DAO"] = "dao";
    NavbarPages["BLOG"] = "blog";
    NavbarPages["BUILDER"] = "builder";
})(NavbarPages = exports.NavbarPages || (exports.NavbarPages = {}));
var Navbar = /** @class */ (function (_super) {
    __extends(Navbar, _super);
    function Navbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            toggle: false,
            showSubMenu: {}
        };
        _this.handleToggle = function (event) {
            _this.setState({ toggle: !_this.state.toggle, showSubMenu: {} });
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        };
        _this.handleDocumentClick = function () {
            _this.setState({ toggle: false });
        };
        _this.handleToggleShowSubMenu = function (event, section) {
            var _a;
            if (_this.props.enableSubMenuSection) {
                var toggle = !!_this.state.showSubMenu[section];
                _this.setState({
                    showSubMenu: (_a = {}, _a[section] = !toggle, _a)
                });
            }
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        };
        _this.handleClickMenuOption = function (e, section) {
            var onClickMenuOption = _this.props.onClickMenuOption;
            if (onClickMenuOption) {
                onClickMenuOption(e, section);
            }
        };
        _this.shouldShowSubMenu = function (section) {
            return _this.props.enableSubMenuSection && _this.state.showSubMenu[section];
        };
        _this.renderMobileMenuItem = function (section, title, href, children) {
            var _a = _this.props, activePage = _a.activePage, enableSubMenuSection = _a.enableSubMenuSection;
            var showSubMenu = enableSubMenuSection && !!children;
            return (React.createElement(React.Fragment, null,
                React.createElement(Menu_1.default.Item, { active: activePage === section, href: !enableSubMenuSection ? href : undefined }, showSubMenu ? (React.createElement(Header_1.Header, { size: "small", className: "dcl active-page ".concat(_this.shouldShowSubMenu(section) ? 'caret-up' : 'caret-down'), onClick: function (e) {
                        return _this.handleToggleShowSubMenu(e, section);
                    } }, title)) : (title)),
                _this.shouldShowSubMenu(section) && children));
        };
        return _this;
    }
    Navbar.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleDocumentClick);
    };
    Navbar.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleDocumentClick);
    };
    Navbar.prototype.renderMarketplaceSubMenu = function () {
        var _this = this;
        var i18n = this.props.i18n;
        return (React.createElement(Menu_1.default.Item, { className: "submenu" },
            React.createElement(Menu_1.default, { vertical: true },
                React.createElement(Menu_1.default.Item, { href: config_1.config.get('MARKETPLACE_URL'), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.MARKETPLACE, "_overview"));
                    } }, i18n.menu.marketplace.overview),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('MARKETPLACE_URL'), "/browse"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.MARKETPLACE, "_collectibles"));
                    } }, i18n.menu.marketplace.collectibles),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('MARKETPLACE_URL'), "/lands"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.MARKETPLACE, "_land"));
                    } }, i18n.menu.marketplace.land),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('MARKETPLACE_URL'), "/names/claim"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.MARKETPLACE, "_names"));
                    } }, i18n.menu.marketplace.names),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('MARKETPLACE_URL'), "/account"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.MARKETPLACE, "_myAssets"));
                    } }, i18n.menu.marketplace.myAssets))));
    };
    Navbar.prototype.renderBuilderSubMenu = function () {
        var _this = this;
        var i18n = this.props.i18n;
        return (React.createElement(Menu_1.default.Item, { className: "submenu" },
            React.createElement(Menu_1.default, { vertical: true },
                React.createElement(Menu_1.default.Item, { href: config_1.config.get('BUILDER_URL'), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.BUILDER, "_overview"));
                    } }, i18n.menu.builder.overview),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('BUILDER_URL'), "/collections"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.BUILDER, "_collections"));
                    } }, i18n.menu.builder.collections),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('BUILDER_URL'), "/scenes"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.BUILDER, "_scenes"));
                    } }, i18n.menu.builder.scenes),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('BUILDER_URL'), "/land"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.BUILDER, "_land"));
                    } }, i18n.menu.builder.land),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('BUILDER_URL'), "/names"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.BUILDER, "_names"));
                    } }, i18n.menu.builder.names),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('BUILDER_URL'), "/worlds"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.BUILDER, "_worlds"));
                    } }, i18n.menu.builder.worlds))));
    };
    Navbar.prototype.renderDocsSubMenu = function () {
        var _this = this;
        var i18n = this.props.i18n;
        return (React.createElement(Menu_1.default.Item, { className: "submenu" },
            React.createElement(Menu_1.default, { vertical: true },
                React.createElement(Menu_1.default.Item, { href: "https://docs.decentraland.org/player", onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DOCS, "_players"));
                    } }, i18n.menu.docs.players),
                React.createElement(Menu_1.default.Item, { href: "https://docs.decentraland.org/creator", onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DOCS, "_creators"));
                    } }, i18n.menu.docs.creators),
                React.createElement(Menu_1.default.Item, { href: "https://docs.decentraland.org/contributor", onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DOCS, "_contributors"));
                    } }, i18n.menu.docs.contributors),
                React.createElement(Menu_1.default.Item, { href: "https://studios.decentraland.org", onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DOCS, "_studios"));
                    } }, i18n.menu.docs.studios))));
    };
    Navbar.prototype.renderPlacesSubMenu = function () {
        var _this = this;
        var i18n = this.props.i18n;
        return (React.createElement(Menu_1.default.Item, { className: "submenu" },
            React.createElement(Menu_1.default, { vertical: true },
                React.createElement(Menu_1.default.Item, { href: config_1.config.get('PLACES_URL'), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.PLACES, "_overview"));
                    } }, i18n.menu.places.overview),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('PLACES_URL'), "/genesis"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.PLACES, "_places"));
                    } }, i18n.menu.places.places),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('PLACES_URL'), "/worlds"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.PLACES, "_worlds"));
                    } }, i18n.menu.places.worlds),
                React.createElement(Menu_1.default.Item, { href: "https://docs.decentraland.org/creator/places/faq", onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.PLACES, "_faq"));
                    } }, i18n.menu.places.faq))));
    };
    Navbar.prototype.renderDaoSubMenu = function () {
        var _this = this;
        var i18n = this.props.i18n;
        return (React.createElement(Menu_1.default.Item, { className: "submenu" },
            React.createElement(Menu_1.default, { vertical: true },
                React.createElement(Menu_1.default.Item, { href: config_1.config.get('DAO_URL'), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DAO, "_overview"));
                    } }, i18n.menu.dao.overview),
                React.createElement(Menu_1.default.Item, { href: config_1.config.get('GOVERNANCE_URL'), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DAO, "_governance"));
                    } }, i18n.menu.dao.governance),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('GOVERNANCE_URL'), "/transparency"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DAO, "_transparency"));
                    } }, i18n.menu.dao.transparency),
                React.createElement(Menu_1.default.Item, { href: "".concat(config_1.config.get('DAO_URL'), "/grants"), onMouseDown: function (e) {
                        return _this.handleClickMenuOption(e, "".concat(NavbarPages.DAO, "_grants"));
                    } }, i18n.menu.dao.grants))));
    };
    Navbar.prototype.renderLeftMobileMenu = function () {
        var i18n = this.props.i18n;
        return (React.createElement(React.Fragment, null,
            this.renderMobileMenuItem(NavbarPages.MARKETPLACE, i18n.menu.marketplace.main, config_1.config.get('MARKETPLACE_URL'), this.renderMarketplaceSubMenu()),
            this.renderMobileMenuItem(NavbarPages.BUILDER, i18n.menu.builder.main, config_1.config.get('BUILDER_URL'), this.renderBuilderSubMenu()),
            this.renderMobileMenuItem(NavbarPages.DOCS, i18n.menu.docs.main, 'https://docs.decentraland.org', this.renderDocsSubMenu()),
            this.renderMobileMenuItem(NavbarPages.PLACES, i18n.menu.places.main, config_1.config.get('PLACES_URL'), this.renderPlacesSubMenu()),
            this.renderMobileMenuItem(NavbarPages.EVENTS, i18n.menu.events, config_1.config.get('EVENTS_URL')),
            this.renderMobileMenuItem(NavbarPages.DAO, i18n.menu.dao.main, config_1.config.get('GOVERNANCE_URL'), this.renderDaoSubMenu()),
            this.renderMobileMenuItem(NavbarPages.BLOG, i18n.menu.blog, 'https://decentraland.org/blog')));
    };
    Navbar.prototype.renderMenuItem = function (section, title, href, children) {
        var _this = this;
        var activePage = this.props.activePage;
        return (React.createElement(Menu_1.default.Item, { active: activePage === section, onMouseEnter: function (e) {
                return _this.handleToggleShowSubMenu(e, section);
            }, onMouseLeave: function (e) {
                return _this.handleToggleShowSubMenu(e, section);
            } },
            React.createElement("a", { className: "item", href: href, onMouseDown: function (e) {
                    return _this.handleClickMenuOption(e, section);
                } }, title),
            this.shouldShowSubMenu(section) && children));
    };
    Navbar.prototype.renderLeftDesktopMenu = function () {
        var i18n = this.props.i18n;
        return (React.createElement(React.Fragment, null,
            this.renderMenuItem(NavbarPages.MARKETPLACE, i18n.menu.marketplace.main, config_1.config.get('MARKETPLACE_URL'), this.renderMarketplaceSubMenu()),
            this.renderMenuItem(NavbarPages.BUILDER, i18n.menu.builder.main, config_1.config.get('BUILDER_URL'), this.renderBuilderSubMenu()),
            this.renderMenuItem(NavbarPages.DOCS, i18n.menu.docs.main, 'https://docs.decentraland.org', this.renderDocsSubMenu()),
            this.renderMenuItem(NavbarPages.PLACES, i18n.menu.places.main, config_1.config.get('PLACES_URL'), this.renderPlacesSubMenu()),
            this.renderMenuItem(NavbarPages.EVENTS, i18n.menu.events, config_1.config.get('EVENTS_URL')),
            this.renderMenuItem(NavbarPages.DAO, i18n.menu.dao.main, config_1.config.get('DAO_URL'), this.renderDaoSubMenu()),
            this.renderMenuItem(NavbarPages.BLOG, i18n.menu.blog, 'https://decentraland.org/blog')));
    };
    Navbar.prototype.renderLeftMenu = function () {
        var _a = this.props, leftMenu = _a.leftMenu, leftMenuDecorator = _a.leftMenuDecorator;
        if (leftMenu && leftMenuDecorator) {
            throw new Error("Unnecessary to provide both 'leftMenu' and 'leftMenuDecorator' props");
        }
        if (leftMenu) {
            return leftMenu;
        }
        var defaultLeftMenu = (React.createElement(React.Fragment, null,
            React.createElement(Media_1.NotMobile, null, this.renderLeftDesktopMenu()),
            React.createElement(Media_1.Mobile, null, this.renderLeftMobileMenu())));
        if (leftMenuDecorator) {
            var Decorator = leftMenuDecorator;
            return React.createElement(Decorator, null, defaultLeftMenu);
        }
        return defaultLeftMenu;
    };
    Navbar.prototype.renderRightMenu = function () {
        var _a = this.props, rightMenu = _a.rightMenu, middleMenu = _a.middleMenu, isConnected = _a.isConnected, onClickAccount = _a.onClickAccount, mana = _a.mana, address = _a.address, isConnecting = _a.isConnecting, isSignIn = _a.isSignIn, i18n = _a.i18n, onSignIn = _a.onSignIn;
        if (rightMenu) {
            return rightMenu;
        }
        else if (isConnected) {
            return (React.createElement(React.Fragment, null,
                middleMenu ? (React.createElement(Media_1.NotMobile, null,
                    React.createElement(Menu_1.default, { secondary: true, className: "dcl navbar-account-menu" }, middleMenu))) : null,
                React.createElement("span", { className: "dcl account-wrapper ".concat(onClickAccount ? 'clickable' : ''), onClick: onClickAccount },
                    mana != null ? (React.createElement(Mana_1.Mana, { size: "small", title: "".concat(mana.toLocaleString(), " MANA") }, Number(mana.toFixed(2)).toLocaleString())) : null,
                    address != null ? React.createElement(Blockie_1.Blockie, { seed: address }) : null)));
        }
        else if (isConnecting && !isSignIn) {
            return (React.createElement(Menu_1.default, { secondary: true },
                React.createElement(Menu_1.default.Item, { disabled: true }, i18n.account.connecting)));
        }
        else if (onSignIn || isSignIn) {
            return (React.createElement(Menu_1.default, { secondary: true },
                React.createElement(Menu_1.default.Item, { className: "sign-in-button", onClick: onSignIn }, i18n.account.signIn)));
        }
        else {
            return null;
        }
    };
    Navbar.prototype.render = function () {
        var _a = this.props, activePage = _a.activePage, className = _a.className, isSignIn = _a.isSignIn, isFullscreen = _a.isFullscreen, isOverlay = _a.isOverlay, isFullWidth = _a.isFullWidth;
        var classes = "dcl navbar";
        if (this.state.toggle) {
            classes += ' open';
        }
        if (isSignIn) {
            classes += ' sign-in';
        }
        if (isFullscreen) {
            classes += ' fullscreen';
        }
        if (isOverlay) {
            classes += ' overlay';
        }
        if (className) {
            classes += " ".concat(className);
        }
        return (React.createElement("div", { className: classes, role: "navigation" },
            React.createElement(Container_1.Container, { className: isFullWidth ? 'full-width' : '' },
                React.createElement("div", { className: "dcl navbar-menu" },
                    React.createElement(Media_1.NotMobile, null,
                        React.createElement(Menu_1.default, { secondary: true, stackable: true },
                            React.createElement("a", { className: "dcl navbar-logo", href: "https://decentraland.org" },
                                React.createElement(Logo_1.Logo, null)),
                            this.renderLeftMenu())),
                    React.createElement(Media_1.Mobile, null,
                        React.createElement("div", { className: "dcl navbar-mobile-menu" },
                            React.createElement("a", { className: "dcl navbar-logo", href: "https://decentraland.org" },
                                React.createElement(Logo_1.Logo, null)),
                            React.createElement(Header_1.Header, { size: "small", className: "dcl active-page ".concat(this.state.toggle ? 'caret-up' : 'caret-down'), onClick: this.handleToggle }, activePage)))),
                React.createElement("div", { className: "dcl navbar-account" }, this.renderRightMenu())),
            React.createElement("div", { className: "mobile-menu" }, this.renderLeftMenu())));
    };
    Navbar.defaultProps = {
        mana: null,
        address: null,
        activePage: null,
        leftMenu: null,
        leftMenuDecorator: null,
        middleMenu: null,
        i18n: {
            menu: {
                marketplace: {
                    main: 'Marketplace',
                    overview: 'Overview',
                    collectibles: 'Collectibles',
                    land: 'LAND',
                    myAssets: 'My Assets',
                    names: 'NAMEs'
                },
                docs: {
                    main: 'Docs',
                    players: 'Players',
                    creators: 'Content Creators',
                    contributors: 'Contributors',
                    studios: 'Studios'
                },
                events: 'Events',
                places: {
                    main: 'Places',
                    overview: 'Overview',
                    places: 'Genesis City',
                    worlds: 'Worlds',
                    faq: 'FAQ'
                },
                agora: 'Agora',
                dao: {
                    main: 'DAO',
                    overview: 'Overview',
                    governance: 'Governance',
                    transparency: 'Transparency',
                    grants: 'Grants'
                },
                blog: 'Blog',
                builder: {
                    main: 'Builder',
                    overview: 'Overview',
                    collections: 'Collections',
                    scenes: 'Scenes',
                    land: 'Land',
                    names: 'Names',
                    worlds: 'Worlds'
                }
            },
            account: {
                signIn: 'Sign In',
                connecting: 'Connecting...'
            }
        },
        isConnected: false,
        isConnecting: false,
        isFullscreen: false,
        isOverlay: false,
        isSignIn: false,
        onSignIn: null,
        onClickAccount: null,
        onClickMenuOption: null,
        isFullWidth: false,
        enableSubMenuSection: true
    };
    return Navbar;
}(React.PureComponent));
exports.Navbar = Navbar;
